module.exports = __webpack_public_path__ + "media/images/flags/64/Guinea-Bissau-54a093b2ea6b4be713021efa6c90d1fc.png";